angular
    .module("home.controller")
    .controller('homeController', ['$scope', '$rootScope', '$filter', '$timeout', '$location', 'browser', 'policySumm',
        'popupService', 'userService', 'commonService', 'policyService', 'commonConst', 'httpService', '$route', 'inboxService', 'claimSumm',
        function ($scope, $rootScope, $filter, $timeout, $location, browser, policySumm,
            popupService, userService, commonService, policyService, commonConst, httpService, $route, inboxService, claimSumm) {
            $rootScope.etlTime;

            $rootScope.PolicyCount = 0;
            $rootScope.PolicyPageCount = [];
            $rootScope.Policies;
            $scope.rowPerPage = 10;
            $rootScope.policyLength;

            $rootScope.policyPageSelected;
            $rootScope.policyHomePageSel;

            $scope.submitted = false;
            $rootScope.deviceCheck;
            $rootScope.deviceType;
            // $rootScope.pageName = 'Home';
            $rootScope.pageLink = "";

            $rootScope.popupMessage = false;
            $rootScope.MyClaims;
            $rootScope.MyClaimsContents = [];

            $scope.isFocusEmail = false;

            $rootScope.myPoliciesPopup = {
                open: false,
                policies: {}
            }

            $scope.policyErrorMessage = null;

            $rootScope.empUpdate;

            $scope.loginType = 'E';

            // $scope.emailPattern = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

            //default select New Sale Wales when display popup select jurisdiction lodge claim
            $rootScope.selectedJurisdiction = 0;

            $rootScope.isVic = false;
            // }

            $rootScope.IsNsiUser = $filter('dec2bool')(sessionStorage.IsNsiUser);

            $scope.credentials = {
                identifier: '',
                password: '',
                dob: '',
                isClaimant: false
            };

            $scope.isLoading = false;
            $scope.isSuccessful = false;

            // Inbox
            $scope.unreadCount = 0;
            $scope.unreadCountClaim = 0;

            $scope.init = function () {
                $scope.pageName = 'Dashboard';
                $scope.hideEtlTime = true;
                $scope.pageMessage = 'Welcome to EMpower';
                //get notification when we got an issue  
                commonService.getNotificationMessage();
                $rootScope.deviceCheck = browser.getBrowserType();
                $rootScope.deviceType = browser.getDeviceType();
                history.pushState('', document.title, window.location.pathname);

                if ($filter('dec2bool')(sessionStorage.LoggedIn)) {
                    userService.setUserArray();
                    userService.checkTermConditionAgree();
                    if($rootScope.user.IsNsiUser) {
                        if($rootScope.IsClaimant) {
                            $scope.getInboxUnreadCount();
                        } else if ($rootScope.user.AllowReviewClaim) {
                            $scope.getNeedReviewClaimCount();
                        }
                    }
                }
            };
            $scope.focus = function () {
                setTimeout(function () {
                    document.getElementById('identifier').focus()
                }, 1000);
            }
            $scope.checkSub = function () {
                $scope.submitted = true;
            };

            //ChangePasswordFeature
            $rootScope.changePasswordPopup = function () {
                var otpions = {
                    showHeader: false,
                    showCloseButton: false,
                    otherTheme: true
                };

                popupService.show('home', 'change-password', otpions);
            };

            $scope.resetValidation = function (loginForm) {
                if (loginForm) {
                    loginForm.identifier.$setValidity('incorrect', null);
                    loginForm.password.$setValidity('incorrect', null);
                    if (loginForm.dob) {
                        loginForm.dob.$setValidity('incorrect', null);
                    }
                    loginForm.$setPristine();
                    loginForm.$setUntouched()
                }
            };


            $rootScope.userLogout = function () {
                userService.logout();
            };

            $scope.getUserPolicyList = function (num, count) {
                //console.log("My Policy Summary list func");
                $rootScope.policyHomePageSel = !$filter('undefined')(num) ? num : $rootScope.policyHomePageSel;
                $rootScope.policyHomePageSel = !$filter('undefined')($rootScope.policyHomePageSel) ? $rootScope.policyHomePageSel : 1;
                $rootScope.policyPageSelected = $rootScope.policyHomePageSel;
                count = count === $filter('undefined')(count) ? $scope.rowPerPage : 10;
                policySumm.getPolicySummary(num, count);
            }; //getPolicyListProjection

            $rootScope.openLink = commonService.openLink;
            $scope.redirectLink = commonService.redirectLink;

            $scope.closeSelectPolicyPopups = function () {
                $rootScope.myPoliciesPopup = {
                    open: false,
                    policies: {}
                };
            };

            //Vic My claims tile
            $rootScope.openSelectPolicyForVicClaim = function () {

                if ($rootScope.IsClaimant) {
                    //Flag flow not access vic claim summary via claim detail
                    $rootScope.pageNavigationHistory.statsWPNumber = null;

                    $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;
                    var APITarget = "api/vicclaims/getvicclaimpagecount";
                    var Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DateOfBirth: $rootScope.user.DateOfBirth,
                        Keyword: $scope.claimSearchString,
                        RowsPerPage: 10,
                        PageNumber: 1,
                        IsClaimant: $rootScope.IsClaimant
                    });

                    httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                        if (data !== false) {
                            if (data === "logout") {
                                $rootScope.userLogout();
                            }
                            $scope.serverResponse = angular.fromJson(data);
                            var claimCount = $scope.serverResponse.Data.length;
                            $rootScope.previousClaimCount = claimCount;

                            if (claimCount === 0) {
                                popupService.showError('You have no claims at the moment.');
                                return;
                            } else if (claimCount > 1) {
                                $rootScope.navigate('/claim-summary-vic');
                            } else {
                                var claim = $scope.serverResponse.Data[0];

                                $rootScope.viewClaimDetail(claim);

                                //Flag flow not access vic claim summary via claim detail
                                $rootScope.navigate('/claim-details-vic');
                            }

                        }

                    });
                }
                else {
                    //If NSI employer
                    if ($rootScope.IsNsiUser) { 
                        $rootScope.navigateToPIClaimSummary();
                    }

                    //ELSE: National employer
                    else {
                        policySumm.getPolicyCount($scope.rowPerPage).then(function (policyCount) {
                            $rootScope.previousPolicyCount = policyCount;
                            if (policyCount == null) {
                                return;
                            } else if (policyCount === 0) {
                                popupService.showError('You have no policies at the moment.');
                                return;
                            } else if (policyCount > 1) {
                                policyService.openPoliciesClaimsSearchForVic('My Claims');
                            } else {
                                //Flag flow not access vic claim summary via claim detail
                                $rootScope.pageNavigationHistory.statsWPNumber = null;
                                $rootScope.navigate('/claim-summary-vic');
                            }
                        });
                    }
                }
                //add audit usage
                var today = new Date();
                var apiTarget = "api/common/addauditusage",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        FeatureName: 'My Claims',
                        UsageDate: today
                    });

                httpService.httpRequest(apiTarget, values, null, 'POST').then(function () {

                });
            }

            $rootScope.navigateToPIClaimSummary = function() {
                //clear search history
                $rootScope.pageNavigationHistory.claimSearchString = null;
                $rootScope.pageNavigationHistory.LstCostCentre = null;
                $rootScope.pageNavigationHistory.LstSelectedStatus = null;
                $rootScope.pageNavigationHistory.nsiClaimSumRowPerPage = null;
                $rootScope.pageNavigationHistory.unreadOnly = null;
                $rootScope.pageNavigationHistory.searchType = 'claimnumber';
                $rootScope.claimsPageSelected = 1;

                $location.path('/claim-summary');
            }


            $rootScope.findMoreRecent = function (policyOrClaim) {
                $rootScope.pageNavigationHistory.searchType = policyOrClaim || 'P';
                $rootScope.searchPageSelected = 1;
                $rootScope.openSelectPolicyForVicClaim();
            }

            //report tile
            $rootScope.openReport = function () {
                var jurisdiction = $rootScope.getSelectedJurisdiction();
                if (jurisdiction === 2) {
                    $location.path('/');
                    return;
                }

                $rootScope.navigate('/claims-performance-report');
            }

            $scope.whoarewe = function () {
                var url = "https://www.eml.com.au/services/state-schemes/victoria/";
                window.open(url, '_blank');
            }

            // National Portal changes Start
            $rootScope.changeJurisdiction = function (jurisdiction) {
                if ($rootScope.getSelectedJurisdiction() !== jurisdiction) {
                    if ($location.path() === '/claims-performance-report') {
                        sessionStorage.SelectedJurisdiction = $filter('enstr64')(jurisdiction);
                        if (jurisdiction === 2) {
                            $location.path('/');
                        } else if (jurisdiction === null || jurisdiction === 0) {
                            $rootScope.openReport();
                        }
                        return;
                    }

                    // assign jurisdiction into session storage first
                    sessionStorage.SelectedJurisdiction = $filter('enstr64')(jurisdiction);
                    $rootScope.searchPageSelected = 1;
                    $rootScope.pageNavigationHistory.filterJurisdiction = null;


                    policySumm.getPolicySummary(1, 10, '').then(function (policies) {
                        var policyId = 0;
                        if ($rootScope.Policies.PolicyList != null && $rootScope.Policies.PolicyList.length > 0) {
                            policyId = $rootScope.Policies.PolicyList[0].EmployerId;
                        }
                        $rootScope.pageNavigationHistory.policy = {
                            PolicyId: policyId
                        };
                        $rootScope.getRecentPoliciesAndClaims();
                        if ($location.path() === '/claim-summary-vic' ||
                            $location.path() === '/claim-details-vic') {
                            $rootScope.openSelectPolicyForVicClaim();
                        } else if ($location.path() === '/claims-performance-report' && jurisdiction === 2) {
                            $location.path('/');
                        } else if ($location.path() !== '/') {
                            $route.reload();
                        }
                    });

                    //reset values to check claim/policy count
                    $rootScope.previousClaimCount = null;
                    $rootScope.previousPolicyCount = null;
                }
            }

            $rootScope.viewClaimSummary = function (policyId, Scheme) {
                $rootScope.pageNavigationHistory.policy = {
                    PolicyId: policyId,
                    Scheme: Scheme
                };
                $rootScope.pageNavigationHistory.statsWPNumber = null;
                // policyService.getPolicyDetailForVic(policyId).then(function (data) {
                //     sessionStorage.Policy = $filter('enstr64')(JSON.stringify(data));
                // });
                sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                $rootScope.claimsPageSelected = 1;
                $rootScope.navigate('/claim-summary-vic');
            }

            $rootScope.viewClaimDetail = function (claim) {
                $rootScope.pageNavigationHistory.policy = {
                    PolicyId: claim.EmployerId,
                    Scheme: claim.Scheme
                };
                $rootScope.pageNavigationHistory.claim = claim;
                // sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.CLAIM);
                // sessionStorage.Policy = $filter('enstr64')(JSON.stringify($rootScope.pageNavigationHistory.policy));
                // sessionStorage.Claim = $filter('enstr64')(JSON.stringify(claim));


                if ($location.path() === '/claim-details' ||
                    $location.path() === '/claim-details-vic') {
                    $route.reload();
                }

            }

            $scope.switchLogin = function (type, loginForm) {
                document.getElementById('identifier').focus();
                $scope.resetValidation(loginForm);
                $scope.loginType = type;
            }

            // National Portal changes End
            $scope.credentials = {
                identifier: '',
                password: '',
                dob: '',
                isClaimant: false
            };

            $scope.setLoading = function() {
                $scope.isLoading = true;
            }

            $scope.userLogin = function (credentials, loginForm) {

                //get notification when we got an issue  
                commonService.getNotificationMessage();

                credentials.dob = $scope.loginType === 'E' ? null : credentials.dob;
                credentials.isClaimant = $scope.loginType === 'C' ? true : false;

                $scope.isLoading = true;
                userService.login(credentials, $rootScope.isUrlVic).then(function (data) { // this is only run after $http completes
                    $scope.isLoading = false;
                    if (data === false) {
                        return;
                    }
                    if (data === "logout") {
                        $rootScope.userLogout();
                    }
                    $scope.serverResponse = angular.fromJson(data);

                    if ($scope.serverResponse === "null" || $scope.serverResponse === null || !$scope.serverResponse.SessionKey) {
                        //If user enters correct username and password but not allowed to login, show server error
                        //Otherwise show validations error and count max log in attempt
                        if (!!$scope.serverResponse.LoginErrorCode && $scope.serverResponse.LoginErrorCode === 61007) {
                            $scope.validLoginType = false;
                            $scope.loginType = 'C';

                        } else if (!!$scope.serverResponse.LoginErrorMessage) {
                            $rootScope.closePopups();
                            popupService.showError($scope.serverResponse.LoginErrorMessage);
                            // alert($scope.serverResponse.LoginErrorMessage);
                        } else {
                            var loginAttempts = $filter('dec2num')(sessionStorage.loginAttempts) || 0;
                            sessionStorage.loginAttempts = $filter('enstr64')(loginAttempts + 1);
                            $scope.credentials.password = "";
                            $scope.credentials.dob = "";
                            $scope.isServerLoginFailed = true;
                            $scope.resetValidation(loginForm);
                        }
                    } else {
                        $scope.isSuccessful = true;

                        // show popup message
                        var controller = {
                            showHeader: false,
                            showCloseButton: false
                        };

                        // update session storage
                        updateSessionStorage();

                        userService.setUserArray(1000);

                        if (!$rootScope.user.IsAcceptTermCondition) {
                            userService.checkTermConditionAgree();
                        }
                        if($rootScope.IsNsiUser) {
                            if($rootScope.IsClaimant) {
                                $scope.getInboxUnreadCount();
                            } else if ($rootScope.user.AllowReviewClaim) {
                                $scope.getNeedReviewClaimCount();
                            }
                        }

                        // get recent policies from rootscope
                        $rootScope.getRecentPoliciesAndClaims();

                        $timeout(function () {

                            if ($scope.serverResponse.IsNsiUser && (!credentials.isClaimant || $scope.serverResponse.IsSuperUser)) //is Pivotal user
                            {
                                //get nsi clients
                                var APITarget = "api/policies/getnsiclient";
                                var values = JSON.stringify({
                                    Identifier: $filter('decstr64')(sessionStorage.Identifier)
                                });

                                httpService.httpRequest(APITarget, values).then(function (data) { // this is only run after $http completes
                                    if (data !== false) {
                                        if (data === "logout") {
                                            $rootScope.userLogout();
                                        }

                                        var clients = angular.fromJson(data);
                                        sessionStorage.setItem('NSIClients', $filter('enstr64')(JSON.stringify(clients)));


                                        //get nsi claims status
                                        var APITarget = "api/claims/getallnsiclaimstatus";

                                        httpService.httpRequest(APITarget).then(function (data) { // this is only run after $http completes
                                            if (data !== false) {
                                                if (data === "logout") {
                                                    $rootScope.userLogout();
                                                }

                                                var lstClaimStatus = angular.fromJson(data);
                                                sessionStorage.setItem('LstClaimStatus', $filter('enstr64')(JSON.stringify(lstClaimStatus)));

                                            } //if data==false
                                        });
                                    } //if data==false
                                });
                            }
                        }, 0);

                        $scope.submitted = false;
                    } //if null
                })
                .catch(function(err) {
                    $scope.isLoading = false;
                });
            }; //validate true



            $scope.passwordResetPopup = function () {
                $rootScope.closePopups();
                $rootScope.passwordResetPopupOn = !$rootScope.passwordResetPopupOn;
            };

            function updateSessionStorage() {
                $rootScope.IsClaimant = $scope.serverResponse.IsClaimant === 1 && $scope.loginType === 'C';
                $rootScope.IsNsiUser = !!$scope.serverResponse.IsNsiUser;
                $rootScope.IsACT = $scope.serverResponse.IsACT;
                _.assign(sessionStorage, {
                    UserId: $filter('enstr64')($scope.serverResponse.UserId),
                    Identifier: $filter('enstr64')($scope.serverResponse.Identifier),
                    DisplayName: $filter('enstr64')($scope.serverResponse.DisplayName),
                    EmailAddress: $filter('enstr64')($scope.serverResponse.EmailAddress),
                    BrokerNumber: "",
                    EtlTime: $scope.serverResponse.EtlTime,
                    // PolicyId: ($filter('undefined')($scope.serverResponse.PolicyId) === true || $scope.serverResponse.PolicyId == null) ? "" : $filter('enstr64')($scope.serverResponse.PolicyId),
                    SessionKey: $filter('enstr64')($scope.serverResponse.SessionKey),
                    LoggedIn: $filter('enstr64')(true),
                    loginAttempts: $filter('enstr64')(0),
                    IsDemoUser: $filter('enstr64')($scope.serverResponse.DemoUser),
                    IsShowPaymentTile: $filter('enstr64')($scope.serverResponse.QWAllUserCanUse || $scope.serverResponse.DemoUser),
                    IsEmployerAddBusiness: $filter('enstr64')(false),
                    DraftEmployer: $filter('enstr64')($scope.serverResponse.DraftEmployer),
                    PolicyNumber: ($filter('undefined')($scope.serverResponse.PolicyNumber) === true || $scope.serverResponse.PolicyId == null) ? "" : $filter('enstr64')($scope.serverResponse.PolicyNumber),
                    TotalEmiusPolicy: $filter('enstr64')($scope.serverResponse.TotalEmiusPolicy),
                    TotalICarePolicy: $filter('enstr64')($scope.serverResponse.TotalIcarePolicy),
                    TotalPolicy: $filter('enstr64')($scope.serverResponse.TotalPolicy),
                    IsSuperUser: $filter('enstr64')($scope.serverResponse.IsSuperUser),
                    IsNsiUser: $filter('enstr64')($scope.serverResponse.IsNsiUser),
                    BusinessUnit: $filter('enstr64')($scope.serverResponse.BusinessUnit),
                    LstCostCentre: $filter('enstr64')(JSON.stringify($scope.serverResponse.LstCostCentre)),
                    ClientId: $filter('enstr64')($scope.serverResponse.ClientId),
                    IsClaimant: $filter('enstr64')($rootScope.IsClaimant),
                    IsACT: $filter('enstr64')($rootScope.IsACT),
                    IsEmployer: $filter('enstr64')($scope.serverResponse.IsEmployer),
                    IsBroker: $filter('enstr64')($scope.serverResponse.IsBroker),
                    DateOfBirth: $filter('enstr64')($scope.credentials.dob),
                    IsAcceptTermCondition: $filter('enstr64')($scope.serverResponse.IsAcceptTermCondition),
                    ListJurisdictionId: $filter('enstr64')($scope.serverResponse.LstJurisdictionId),
                    AllowReviewClaim: $filter('enstr64')($scope.serverResponse.AllowReviewClaim),
                });
                var businessUnit = $scope.serverResponse.BusinessUnit.length > 1 ? null : $scope.serverResponse.BusinessUnit[0];
                sessionStorage.SelectedJurisdiction = $filter('enstr64')(businessUnit);
            }

            function setIncorrectInputValue(loginForm) {
                if (loginForm) {
                    loginForm.identifier.$setValidity('incorrect', false);
                    loginForm.password.$setValidity('incorrect', false);
                    if ($scope.loginType === 'C') {
                        loginForm.dob.$setValidity('incorrect', false);
                    }
                }
            }

            function fieldInvalid(formField, errorType) {
                return formField && formField.$error[errorType];
            }

            function identifierMaxlength(identifier) {
                return identifier && identifier.$error.maxlength;
            }

            $scope.anyFieldInvalid = function (form, errorType) {
                return (fieldInvalid(form.identifier, errorType) ||
                    fieldInvalid(form.password, errorType) ||
                    (fieldInvalid(form.dob, errorType) && $scope.loginType === 'C'));
            };

            $scope.checkFormValidation = function (loginForm) {
                return loginForm.$submitted && !loginForm.identifier.$error.maxlength && !loginForm.identifier.$error.pattern &&
                    ($scope.anyFieldInvalid(loginForm, 'required') ||
                        $scope.anyFieldInvalid(loginForm, 'incorrect'));
            };

            $scope.resetFieldValidation = function (formField, loginForm) {
                if (loginForm) {
                    // loginForm.$setPristine();
                }
                if (formField) {
                    formField.$setValidity('incorrect', null);
                }
            };

            $scope.resetServerError = function() {
                $scope.isServerLoginFailed = false;
            }

            $scope.getInboxUnreadCount = function() {
                inboxService.getUnreadDocumentCount().then(function(response) {
                    $scope.unreadCount = response;
                });
            }

            $scope.getNeedReviewClaimCount = function() {
                claimSumm.getNeedReviewClaimCount().then(function(response) {
                    $scope.unreadCountClaim = response;
                });
            }

            $scope.getCountDisplay = function(count) {
                return count <= 100 ? count : '99+';
            }
        }
    ]);